import { AddWallet, Login, Prelogin, Register, SignWallet, Status, UserStatus } from './api/api';
import { cfgBrand, cfgBrandTitle } from '@infinitro/config';
import { translate, Verbiage } from '@infinitro/content';
import { handleRequestEmailVerifyCode } from '@infinitro/email_verify';
import { Api, closeThisModal, getStoredPublicKey, isSuccessStatus, locale, loggedIn, ModalDialog, modalStack, posthog, pushModal, sha256ToBase64, showLoading, Stage, stage, stateOpenModal, statePlayerId, stateShowGeoBlockFooter, stateShowSeal, stateShowSealText, successCodes, queueOptimoveAuthEvent, verifyToken } from '@infinitro/global';
import { preAuth, stateCampaignCode, stateCampaignShortcode, stateFingerprint, stateStag, stateVisit } from '@infinitro/visit';
import { disconnect, disconnectIfInitialized, stateConnectedWalletAddress, stateConnectedWalletSigned } from '@infinitro/wallet_verify';
import * as jose from 'jose';
import { derived, get, writable } from 'svelte/store';
import { FormMode, LoginBy } from './types';
import { humanizeAuthError } from './utils/authErrors';
export const thisModal = ModalDialog.Auth;
export const closeModal = () => closeThisModal(thisModal);
export const modalIndex = derived(modalStack, ($modalStack) => $modalStack.findIndex((e) => e.modal === thisModal));
export const isModalOpen = derived(modalIndex, ($modalIndex) => $modalIndex >= 0);
export const payload = derived(modalStack, ($modalStack) => $modalStack.find((e) => e.modal === thisModal)?.data);
export const zOverlay = derived(modalIndex, ($modalIndex) => $modalIndex >= 0 ? 9999 + $modalIndex * 2 : 9999);
export const stateTab = derived(payload, ($payload) => $payload?.tab);
const AUTO_LOGIN = true;
const AUTO_REGISTER = true;
const brand = cfgBrand();
const DEBUG = stage !== Stage.Prod;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function log(msg, data) {
    if (DEBUG)
        console.log(msg, data);
}
export const stateBonusCode = writable('');
export const stateBonusCodeConfirmed = writable(false);
export const stateFormMode = writable(FormMode.Login);
export const stateEmail = writable('');
export const stateEmailRegistered = writable(undefined);
export const stateEmailVerified = writable(false);
export const stateEmailVerifyKey = writable(undefined);
export const stateEmailVerifyStatus = writable(undefined);
export const stateError = writable(undefined);
export const stateGeoblockReg = writable(undefined);
export const stateGoogleToken = writable(undefined);
export const stateInitialized = writable(false);
export const statePassword = writable(undefined);
export const statePasswordEnabled = writable(false);
export const statePasswordIncorrect = writable(false);
export const statePasswordRequired = writable(false);
export const statePasswordSet = writable(false);
export const statePreauthenticated = writable(false);
export const stateReady = writable(false);
export const stateReferalCode = writable('');
export const stateReferalCodeConfirmed = writable(false);
export const stateRegistered = writable(undefined);
export const stateShow = writable(null);
export const stateShowPassword = writable(false);
export const stateShowTotpSetup = writable(false);
export const stateShowTotpVerify = writable(false);
export const stateShowVerifyEmail = writable(false);
export const stateSubmitting = writable(false);
export const stateTermsConfirmed = writable(false);
export const stateTotpCode = writable(undefined);
export const stateTotpCandidate = writable(undefined);
export const stateTotpEnabled = writable(false);
export const stateTotpRequired = writable(false);
export const stateTotpSecret = writable(undefined);
export const stateTotpSet = writable(false);
export const stateUsername = writable('');
export const stateUsernameConfirmed = writable(false);
export const stateWalletAddress = writable('');
export const stateWalletRegistered = writable(undefined);
export const stateWalletConfirmed = writable(false);
export const stateWalletNonce = writable(undefined);
export const stateWalletVerified = writable(false);
export const stateWalletVerifyKey = writable(undefined);
export const emailChecksStarted = [];
let isLoggedIn = undefined;
let emailRegistered = undefined;
let email = '';
let emailVerified = false;
let fingerprint = undefined;
let formMode = FormMode.Login;
let formModeLockByPass = false;
let googleAuthToken = undefined;
let language = 'en';
let password = undefined;
let passwordEnabled = false;
let passwordRequired = false;
let passwordSet = false;
let pwdver = 0;
let termsConfirmed = false;
let totpCode = undefined;
let totpEnabled = false;
// let totpRequired = false;
let totpSecret = undefined;
let totpSet = false;
let walletAddress = '';
let walletConfirmed = false;
let lastGeoBlockPayload = undefined;
export const stateReset = () => {
    stateBonusCode.set('');
    stateBonusCodeConfirmed.set(false);
    stateError.set(undefined);
    stateEmail.set('');
    stateEmailVerified.set(false);
    stateEmailRegistered.set(undefined);
    stateEmailVerifyKey.set(undefined);
    stateEmailVerifyStatus.set(undefined);
    stateGeoblockReg.set(undefined);
    stateGoogleToken.set(undefined);
    stateInitialized.set(false);
    statePassword.set(undefined);
    statePasswordEnabled.set(false);
    statePasswordIncorrect.set(false);
    statePasswordRequired.set(false);
    statePasswordSet.set(false);
    statePreauthenticated.set(false);
    stateReady.set(false);
    stateReferalCode.set('');
    stateReferalCodeConfirmed.set(false);
    stateShowPassword.set(false);
    stateShowTotpSetup.set(false);
    stateShowTotpVerify.set(false);
    stateShowVerifyEmail.set(false);
    stateSubmitting.set(false);
    stateTermsConfirmed.set(false);
    stateTotpCode.set(undefined);
    stateTotpEnabled.set(false);
    stateTotpRequired.set(false);
    stateTotpSecret.set(undefined);
    stateTotpSet.set(false);
    stateUsername.set('');
    stateUsernameConfirmed.set(false);
    stateWalletAddress.set('');
    stateWalletConfirmed.set(false);
    stateWalletRegistered.set(undefined);
    stateWalletVerified.set(false);
    stateWalletVerifyKey.set(undefined);
    disconnectIfInitialized();
    stateConnectedWalletAddress.set('');
    stateConnectedWalletSigned.set(false);
};
export const resetPrelogin = () => {
    stateError.set(undefined);
    stateEmailVerified.set(false);
    stateEmailRegistered.set(undefined);
    stateEmailVerifyKey.set(undefined);
    statePasswordSet.set(false);
    statePasswordEnabled.set(false);
    statePasswordRequired.set(false);
    statePassword.set(undefined);
    stateShowPassword.set(false);
    stateTotpSet.set(false);
    stateTotpEnabled.set(false);
    stateTotpRequired.set(false);
    stateGoogleToken.set(undefined);
    stateWalletConfirmed.set(false);
    stateWalletConfirmed.set(false);
    stateWalletRegistered.set(undefined);
};
const statePreAuthCache = writable(undefined);
let preAuthRequest;
let preAuthRequestKey;
let preAuthCacheKey;
const getPreAuthContextKey = () => {
    return `${get(stateVisit) ?? ''}|${get(stateFingerprint) ?? ''}|${get(locale) ?? ''}`;
};
const isPreAuthContextReady = () => {
    return Boolean(get(stateVisit) && get(stateFingerprint));
};
const invalidatePreAuthCache = (reason) => {
    if (preAuthCacheKey || get(statePreAuthCache)) {
        log(`invalidating preAuth cache: ${reason}`);
    }
    preAuthCacheKey = undefined;
    statePreAuthCache.set(undefined);
};
const fetchPreAuth = async (contextKey) => {
    if (preAuthRequest && preAuthRequestKey === contextKey)
        return preAuthRequest;
    preAuthRequestKey = contextKey;
    preAuthRequest = preAuth();
    try {
        return await preAuthRequest;
    }
    finally {
        preAuthRequest = undefined;
        preAuthRequestKey = undefined;
    }
};
const applyPreAuthData = (data) => {
    log(`preAuthentication: ${JSON.stringify(data, null, 2)}`);
    statePasswordRequired.set(data.pwdRequired);
    stateTotpRequired.set(data.totpRequired);
    if (data.totpCandidate)
        stateTotpCandidate.set(data.totpCandidate);
    stateInitialized.set(true);
    const hasGeoBlockFlags = data.countryBanHard ||
        data.countryBanSoft ||
        data.regionBanHard ||
        data.regionBanSoft ||
        data.regionBanLogin ||
        data.countryBanLogin ||
        data.regionBanReg ||
        data.countryBanReg ||
        data.regionBanSession ||
        data.countryBanSession;
    if (hasGeoBlockFlags) {
        stateShowGeoBlockFooter.set(true);
    }
    else {
        stateShowSealText.set(true);
        stateShowSeal.set(true);
    }
    if (data.regionBanHard || data.regionBanLogin || data.regionBanSession) {
        pushModal(ModalDialog.Geoblock, {
            label: `${data.regionName} (${data.countryCode})`,
            hard: data.regionBanHard
        });
    }
    else if (data.countryBanHard || data.countryBanLogin || data.countryBanSession) {
        pushModal(ModalDialog.Geoblock, { label: `${data.countryName}`, hard: data.countryBanHard });
    }
    else if (data.regionBanReg) {
        stateGeoblockReg.set({ label: `${data.regionName} (${data.countryCode})`, hard: false });
    }
    else if (data.countryBanReg) {
        stateGeoblockReg.set({ label: `${data.countryName}`, hard: false });
    }
    // Do not cache geoblock results so the modal can reappear on later opens.
    if (hasGeoBlockFlags) {
        invalidatePreAuthCache('geoblock flags present');
    }
    statePreauthenticated.set(true);
};
const showGeoBlockAfterAuth = () => {
    if (!lastGeoBlockPayload)
        return;
    pushModal(ModalDialog.Geoblock, lastGeoBlockPayload);
};
// Returns true if cache was available and applied synchronously (no network call needed).
export const applyPreAuthIfCached = () => {
    const contextKey = getPreAuthContextKey();
    if (preAuthCacheKey && preAuthCacheKey !== contextKey) {
        invalidatePreAuthCache('context changed before auth modal open');
    }
    const cached = get(statePreAuthCache);
    if (cached && preAuthCacheKey !== contextKey)
        return false;
    if (!cached)
        return false;
    applyPreAuthData(cached);
    return true;
};
export const preAuthentication = async () => {
    // Refresh preauth automatically when network/session context changes.
    if (applyPreAuthIfCached())
        return;
    const contextKey = getPreAuthContextKey();
    const data = await fetchPreAuth(contextKey);
    if (!data)
        throw new Error('preauthentication call failed');
    if (contextKey === getPreAuthContextKey()) {
        preAuthCacheKey = contextKey;
        statePreAuthCache.set(data);
    }
    applyPreAuthData(data);
};
export const isReady = (allowAutoSubmit, forceAutoSubmit) => {
    if (passwordRequired && !passwordSet) {
        log(`[isReady] password required but not set`);
        return [false, null];
    }
    // if (totpRequired && !totpSet) {
    // 	log(`totp required but not set`);
    // 	return [false, null];
    // }
    if (formMode === FormMode.Login) {
        if (emailRegistered === true && email && emailVerified && get(stateEmailVerifyKey)) {
            if (allowAutoSubmit && (AUTO_LOGIN || forceAutoSubmit))
                submit();
            return [true, LoginBy.Email];
        }
        if (get(stateWalletRegistered) === true &&
            get(stateConnectedWalletAddress) &&
            get(stateWalletVerifyKey)) {
            if (allowAutoSubmit && (AUTO_LOGIN || forceAutoSubmit))
                submit();
            return [true, LoginBy.Wallet];
        }
        log(`wallet or email required and not set or verified`);
    }
    if (formMode === FormMode.Register) {
        if (!termsConfirmed) {
            log(`terms not confirmed`);
            return [false, null];
        }
        if (emailRegistered === false && email && emailVerified && get(stateEmailVerifyKey)) {
            if (allowAutoSubmit && (AUTO_REGISTER || forceAutoSubmit))
                submit();
            return [true, LoginBy.Email];
        }
        if (get(stateWalletRegistered) === false &&
            get(stateConnectedWalletAddress) &&
            get(stateWalletVerifyKey)) {
            if (allowAutoSubmit && (AUTO_REGISTER || forceAutoSubmit))
                submit();
            return [true, LoginBy.Wallet];
        }
        log(`wallet or email required and not set or verified`);
    }
    return [false, null];
};
export const prelogin = async (loginBy, emailVerifyKey, googleAuthToken, walletVerifyKey) => {
    try {
        const publicKey = (await getStoredPublicKey()) ?? '';
        const variables = {
            visitId: get(stateVisit),
            brand,
            email: loginBy === LoginBy.Email ? email : undefined,
            emailVerifyKey: loginBy === LoginBy.Email ? emailVerifyKey : undefined,
            googleAuthToken: loginBy === LoginBy.Google ? googleAuthToken : undefined,
            publicKey,
            fingerprint,
            wallet: loginBy === LoginBy.Wallet ? get(stateConnectedWalletAddress) : undefined,
            walletVerifyKey: loginBy === LoginBy.Wallet ? walletVerifyKey : undefined
        };
        log(`prelogin variables [${loginBy}]: ${JSON.stringify(variables)}`);
        stateSubmitting.set(true);
        const result = await Prelogin({ variables, context: { api: Api.public } });
        stateSubmitting.set(false);
        log(`prelogin result: ${JSON.stringify(result)}`);
        if (!result?.data?.prelogin) {
            return undefined;
        }
        const prelogin = result?.data?.prelogin;
        prelogin.pwdRequired = prelogin.pwdRequired && loginBy !== LoginBy.Google; // todo: after passwords are globally disabled, remove the google condition here so they can be selectively enabled by the player
        if (prelogin.emailVerifyStatus === 'OK' && prelogin.emailVerifyKey) {
            stateEmailVerified.set(true);
            stateEmailVerifyKey.set(prelogin.emailVerifyKey);
            if (prelogin.totpCandidate)
                stateTotpCandidate.set(prelogin.totpCandidate);
        }
        else {
            stateEmailVerified.set(false);
            stateEmailVerifyKey.set(undefined);
            log('prelogin.emailVerifyStatus', prelogin.emailVerifyStatus);
            stateEmailVerifyStatus.set(prelogin.emailVerifyStatus);
        }
        if (prelogin.walletVerifyStatus === 'OK' && walletVerifyKey) {
            stateWalletVerified.set(true);
            stateWalletVerifyKey.set(walletVerifyKey);
        }
        else {
            stateWalletVerified.set(false);
            stateWalletVerifyKey.set(undefined);
        }
        if (prelogin.statusCode === 'AVAILABLE') {
            if (prelogin.emailStatus === 'NOT_FOUND')
                stateEmailRegistered.set(false);
            if (prelogin.walletStatus === 'NOT_FOUND')
                stateWalletRegistered.set(false);
            formModeLockByPass = true;
            stateFormMode.set(FormMode.Register);
            statePasswordRequired.set(prelogin.pwdRequired);
            stateTotpRequired.set(prelogin.totpRequired);
            stateShowPassword.set(prelogin.pwdRequired);
        }
        else if (prelogin.playerId) {
            formModeLockByPass = true;
            stateFormMode.set(FormMode.Login);
            prelogin.pwdEnabled = prelogin.pwdEnabled && loginBy !== LoginBy.Google; // todo: after passwords are globally disabled, remove the google condition here so they can be selectively enabled by the player
            pwdver = prelogin.pwdver;
            if (prelogin.emailStatus && !['NOT_FOUND', 'NULL'].includes(prelogin.emailStatus))
                stateEmailRegistered.set(true);
            if (prelogin.walletStatus && !['NOT_FOUND', 'NULL'].includes(prelogin.walletStatus))
                stateWalletRegistered.set(true);
            if (prelogin.statusCode !== 'OK' ||
                !['ACTIVE'].includes(prelogin.userStatus) ||
                !['ACTIVE', 'NOT_FOUND', 'NULL'].includes(prelogin.emailStatus) ||
                !['ACTIVE', 'NOT_FOUND', 'NULL'].includes(prelogin.walletStatus)) {
                stateError.set(` `);
                return prelogin;
            }
            statePasswordEnabled.set(prelogin.pwdEnabled);
            stateTotpEnabled.set(prelogin.totpEnabled);
            statePasswordRequired.set(prelogin.pwdRequired || prelogin.pwdEnabled);
            stateShowPassword.set(prelogin.pwdRequired || prelogin.pwdEnabled);
            stateTotpRequired.set(prelogin.totpRequired || prelogin.totpEnabled);
        }
        if (prelogin.statusCode === 'AVAILABLE' && get(stateGeoblockReg))
            pushModal(ModalDialog.Geoblock, get(stateGeoblockReg));
        else
            stateReady.set(isReady(true)[0]);
        return prelogin;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (e) {
        stateSubmitting.set(false);
        const err = e?.message ?? e?.toString() ?? 'unknown prelogin error';
        stateError.set(humanizeAuthError(err));
        console.log(`prelogin error: ${e}`);
        posthog.capture('prelogin error', { visitId: get(stateVisit), error: e });
    }
    return undefined;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onGoogleSignIn = async (response) => {
    showLoading.set(true);
    try {
        const jwt = jose.decodeJwt(response.credential);
        if (!jwt) {
            console.log(`invalid Google credential: ${JSON.stringify(response, null, 4)}`);
            return;
        }
        jwt.email = jwt.email?.toLowerCase();
        // important, must be gmail or a google workspace (HD set) for Google to be authoritative
        // if not verified or not authoritative, just use as a shortcut to populate email and request email verification by code
        if (!jwt.email_verified || (!jwt.hd && !jwt.email.endsWith('@gmail.com'))) {
            console.log(`Google email not verified or not authoritative for ${jwt.email}`);
            stateEmail.set(jwt.email);
            let [success, status] = await handleRequestEmailVerifyCode(jwt.email, false, false);
            if (success) {
                stateShowVerifyEmail.set(true);
            }
            else {
                stateError.set(status);
            }
            return;
        }
        stateEmail.set(jwt.email);
        stateGoogleToken.set(response.credential);
        const result = await prelogin(LoginBy.Google, undefined, response.credential);
        showLoading.set(false);
        if (!result)
            return;
    }
    catch (e) {
        showLoading.set(false);
        console.log(`error verifying Google credentails: ${e}`);
    }
};
export const startEmailVerify = async (event, isBlur) => {
    event?.preventDefault();
    if (emailVerified || get(stateEmailVerifyKey) || googleAuthToken)
        return;
    if (isBlur && emailChecksStarted.includes(email)) {
        // if we automatically opened the email verification for the given email once on blur, we don't want to do it again
        return;
    }
    emailChecksStarted.push(email);
    pushModal(ModalDialog.EmailVerify, {
        email,
        label: email,
        requestOnOpen: true,
        handleConfirmedEmailVerifyCode: (verifiedKey, email) => {
            console.log(`added email: ${verifiedKey} ${email}`);
            closeThisModal(ModalDialog.AddEmail);
            stateEmail.set(email);
            stateEmailVerified.set(true);
            stateEmailVerifyKey.set(verifiedKey);
            prelogin(LoginBy.Email, verifiedKey);
        }
    });
};
export const handleConfirmedEmailVerifyCode = async (verifiedKey, email) => {
    if (email)
        stateEmail.set(email);
    if (!verifiedKey)
        return;
    stateEmailVerified.set(true);
    stateEmailVerifyKey.set(verifiedKey);
    stateShowVerifyEmail.set(false);
    await prelogin(LoginBy.Email, verifiedKey);
};
stateConnectedWalletAddress.subscribe(async (value) => {
    // auto-trigger wallet signature on connect only if in authentication flow
    if (!get(modalStack).some((e) => e.modal === ModalDialog.Auth))
        return;
    if (value && !get(stateConnectedWalletSigned)) {
        const vars = {
            variables: {
                visitId: get(stateVisit),
                addressStr: get(stateConnectedWalletAddress)
            },
            context: {
                api: Api.public
            }
        };
        const result = await AddWallet(vars);
        const data = result?.data?.addWallet;
        const nonce = `${data?.id ?? ''}`.replace(/-/g, '');
        console.log('addWallet result', data);
        const sessionStatus = data?.sessionStatus;
        const formMode = sessionStatus === UserStatus.REQUESTED ? FormMode.Register : FormMode.Login;
        if (isSuccessStatus(data?.status ?? Status.FAILED) && nonce) {
            stateWalletRegistered.set(formMode === FormMode.Login);
            formModeLockByPass = true;
            stateFormMode.set(formMode);
            stateWalletNonce.set(nonce);
            getSignature();
        }
        else {
            console.error('addWallet failed', data, nonce);
        }
    }
});
export const onSign = async (e) => {
    getSignature();
};
const getSignature = async () => {
    try {
        const nonce = get(stateWalletNonce);
        const formMode = get(stateFormMode);
        const address = get(stateConnectedWalletAddress);
        if (!nonce || !address || !formMode) {
            console.error('nonce, address or formMode not set', nonce, address, formMode);
            return;
        }
        const modalData = {
            address,
            title: formMode === FormMode.Login
                ? translate(Verbiage.login_via_wallet)
                : translate(Verbiage.signup_via_wallet),
            statement: translate(Verbiage.i_confirm_enabling_signin_to_brand_with_this_wallet).replace('[BRAND]', cfgBrandTitle()),
            content: translate(Verbiage.confirm_age_terms),
            nonce,
            formMode,
            onSigned: async (signedMessage) => {
                const vars = {
                    variables: {
                        visitId: get(stateVisit),
                        addressStr: get(stateConnectedWalletAddress),
                        message: signedMessage.message,
                        signature: signedMessage.signature
                    },
                    context: {
                        api: Api.public
                    }
                };
                const result = await SignWallet(vars);
                const data = result?.data?.signWallet;
                const verifyKey = data?.id;
                if (data?.status === Status.OK && verifyKey) {
                    stateTermsConfirmed.set(true);
                    prelogin(LoginBy.Wallet, undefined, undefined, verifyKey);
                }
                return [data?.status === Status.OK, data?.status];
            },
            onCancel: async () => {
                return [true, undefined];
            }
        };
        pushModal(ModalDialog.WalletVerify, modalData);
    }
    catch (error) {
        console.error('error signing', error);
    }
};
const getOptimoveAuthMethod = () => {
    if (email)
        return 'email';
    if (get(stateConnectedWalletAddress))
        return 'wallet';
    return undefined;
};
const getPlayerIdFromAuthToken = (token) => {
    try {
        return jose.decodeJwt(token).player_id;
    }
    catch {
        return undefined;
    }
};
const queueOptimoveAuthEventForRedirect = (event, authMethod, playerId) => {
    const id = playerId ?? get(statePlayerId);
    if (!id)
        return;
    queueOptimoveAuthEvent({
        event,
        playerId: id,
        authMethod,
        email: event === 'registration' ? email : undefined,
        visitId: get(stateVisit) ?? undefined
    });
};
export const submit = async (event) => {
    showLoading.set(true);
    event?.preventDefault();
    try {
        if (!isReady(false)) {
            log(`form was not ready for submission`);
            showLoading.set(false);
            return [false, undefined];
        }
        if (!((get(stateConnectedWalletAddress) && get(stateWalletVerifyKey)) ||
            (email && emailVerified && get(stateEmailVerifyKey)))) {
            log(`neither email nor wallet are verified`);
            showLoading.set(false);
            return [false, undefined];
        }
        if (formMode === FormMode.Register && totpEnabled && !totpSet && get(stateTotpCandidate)) {
            showLoading.set(false);
            pushModal(ModalDialog.TotpSetup, {
                label: email,
                secret: get(stateTotpCandidate),
                onClose: () => {
                    closeThisModal(ModalDialog.TotpSetup);
                    return true;
                },
                onSetupComplete: (secret, otp) => {
                    stateTotpSecret.set(secret);
                    stateTotpSet.set(true);
                    closeThisModal(ModalDialog.TotpSetup);
                    return true;
                }
            });
            return [false, undefined];
        }
        if (formMode === FormMode.Login && totpEnabled && !totpSet) {
            pushModal(ModalDialog.TotpVerify, {
                label: email,
                numInputs: 6,
                onClose: () => {
                    stateTotpSet.set(false);
                    stateTotpSecret.set('');
                    closeThisModal(ModalDialog.TotpVerify);
                    return true;
                },
                onInputComplete: async (otpCode) => {
                    stateTotpCode.set(otpCode);
                    stateTotpSet.set(true);
                    const [success, status] = await submit();
                    if (success) {
                        closeThisModal(ModalDialog.TotpVerify);
                    }
                    return [success, status];
                }
            });
            showLoading.set(false);
            return [false, undefined];
        }
        const publicKey = (await getStoredPublicKey()) ?? '';
        let passwordHash = undefined;
        if (passwordSet && password) {
            passwordHash = await sha256ToBase64(password);
        }
        if (formMode === FormMode.Login) {
            const variables = {
                brand,
                email: email ? email : undefined,
                emailVerifyKey: get(stateEmailVerifyKey) || undefined,
                wallet: get(stateConnectedWalletAddress) || undefined,
                walletVerifyKey: get(stateWalletVerifyKey) || undefined,
                passwordHash: pwdver === 1 ? password : passwordHash, // v1-compat
                googleAuthToken,
                totpCode,
                publicKey,
                fingerprint,
                visitId: get(stateVisit),
                language
            };
            log(`Login Variables: ${JSON.stringify(variables, null, 2)}`);
            stateSubmitting.set(true);
            const result = await Login({ variables, context: { api: Api.public } });
            stateSubmitting.set(false);
            log(`Login Result: ${JSON.stringify(result, null, 2)}`);
            if (!result?.data?.login) {
                console.log(`login failed no data returned: ${JSON.stringify(result)}`);
                posthog.capture('login failed no data returned', { visitId: get(stateVisit) });
                showLoading.set(false);
                return [false, undefined];
            }
            const login = result?.data?.login;
            if (login.statusCode === 'OK' && login.sessionId && login.token) {
                const playerId = getPlayerIdFromAuthToken(login.token);
                queueOptimoveAuthEventForRedirect('login', getOptimoveAuthMethod(), playerId);
                if ((await verifyToken(login.token, true, login.redirectTo)) && isLoggedIn) {
                    closeThisModal(ModalDialog.Auth);
                    showLoading.set(false);
                    showGeoBlockAfterAuth();
                    return [true, login.statusCode];
                }
            }
            if (!['OK', 'NULL'].includes(login.passwordStatus)) {
                statePasswordIncorrect.set(true);
                showLoading.set(false);
                return [false, login.passwordStatus];
            }
            if (!['OK', 'NULL'].includes(login.totpStatus)) {
                log(`failed TOTP status`);
                showLoading.set(false);
                return [false, login.totpStatus];
            }
            console.log(`unhandled login failure: ${JSON.stringify(login, null, 2)}`);
            posthog.capture('unhandled login failure', {
                visitId: get(stateVisit),
                status: login.statusCode
            });
            showLoading.set(false);
            return [false, login.statusCode];
        }
        else if (formMode === FormMode.Register) {
            pwdver = 1; // v1-compat (change to pwdver = 2 after v1 auth is completely deprecated)
            const variables = {
                brand,
                email: email ? email : undefined,
                emailVerifyKey: get(stateEmailVerifyKey) || undefined,
                walletVerifyKey: get(stateWalletVerifyKey) || undefined,
                wallet: get(stateConnectedWalletAddress) || undefined,
                passwordHash: pwdver === 1 ? password : passwordHash, // v1-compat
                googleAuthToken,
                totpSecret: totpSet ? totpSecret : undefined,
                pwdver,
                publicKey,
                fingerprint,
                visitId: get(stateVisit),
                language
            };
            log(`Register posting ${JSON.stringify(variables, null, 2)}`);
            stateSubmitting.set(true);
            const result = await Register({ variables, context: { api: Api.public } });
            stateSubmitting.set(false);
            log(`Register result ${JSON.stringify(result, null, 2)}`);
            if (!result?.data?.register) {
                console.log(`register failed no data returned: ${JSON.stringify(result)}`);
                posthog.capture('register failed no data returned', { visitId: get(stateVisit) });
                showLoading.set(false);
                return [false, undefined];
            }
            const register = result?.data?.register;
            if (register.statusCode === 'OK' && register.sessionId && register.token) {
                sessionStorage.setItem('new-user', 'true');
                const playerId = getPlayerIdFromAuthToken(register.token);
                queueOptimoveAuthEventForRedirect('registration', getOptimoveAuthMethod(), playerId);
                if ((await verifyToken(register.token, true, register.redirectTo)) && isLoggedIn) {
                    closeThisModal(ModalDialog.Auth);
                    // hotreload
                    showLoading.set(false);
                    showGeoBlockAfterAuth();
                    return [true, register.statusCode];
                }
            }
            if (register.emailVerifyStatus !== 'OK') {
                stateEmailVerified.set(false);
                stateEmailVerifyKey.set(undefined);
                showLoading.set(false);
                log(`register failed on emailVerifyStatus: ${register.emailVerifyStatus}`);
            }
            if (register.userStatus !== 'ACTIVE') {
                showLoading.set(false);
                log(`register failed on userStatus: ${register.userStatus}`);
            }
            if (!['ACTIVE', 'NULL'].includes(register.geoStatus)) {
                showLoading.set(false);
                log(`register failed on geoStatus ${register.geoStatus}`);
            }
            if (!['ACTIVE', 'NULL'].includes(register.passwordStatus)) {
                showLoading.set(false);
                log(`register failed on passwordStatus ${register.passwordStatus}`);
            }
            // if (!['ACTIVE', 'NULL'].includes(register.totpStatus)) {
            // 	log(`register failed on totpStatus ${register.totpStatus}`);
            // }
            log(`register failed: ${JSON.stringify(register, null, 2)}`);
            showLoading.set(false);
            return [false, register.statusCode];
        }
        log(`unhandled submission path`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (e) {
        stateSubmitting.set(false);
        const err = e?.message ?? `${e}` ?? 'unknown login error';
        stateError.set(humanizeAuthError(err));
        posthog.capture('unhandled login or register error', { visitId: get(stateVisit), error: e });
        showLoading.set(false);
    }
    return [false, undefined];
};
export const handleTotpVerifyComplete = async (otp) => {
    log(`auth modal: totp verify complete with otp: ${otp}`);
    stateTotpCode.set(otp);
    stateTotpSet.set(true);
    const [success, status] = await submit();
    if (success) {
        stateShowTotpVerify.set(false);
    }
    return [success, status];
};
stateShow.subscribe((value) => {
    if (value)
        stateFormMode.set(value);
});
stateGoogleToken.subscribe((value) => {
    // only set Google token if Google is authoritative for the email
    // otherwise it's just a shortcut for email entry
    googleAuthToken = value;
    stateShowVerifyEmail.set(false);
    stateEmailVerified.set(true);
});
locale.subscribe((value) => {
    language = value;
});
stateEmail.subscribe((value) => {
    if (email === value)
        return;
    log(`email changed: ${email} -> ${value}`);
    email = value;
    resetPrelogin();
    // if (value) {
    // 	stateReady.set(isReady(true)[0]);
    // } else stateReady.set(false);
});
stateTermsConfirmed.subscribe((value) => {
    termsConfirmed = value;
    if (value)
        stateReady.set(isReady(true)[0]);
    else
        stateReady.set(false);
});
statePasswordSet.subscribe((value) => {
    passwordSet = value;
    if (value)
        stateReady.set(isReady(false)[0]);
    else
        stateReady.set(false);
});
statePassword.subscribe((value) => {
    password = value;
});
stateFormMode.subscribe((value) => {
    formMode = value;
    if (!formModeLockByPass) {
        // clears verified email and wallet when switching form modes as prelogin as already indicated the correct mode
        if (emailVerified) {
            stateEmail.set('');
        }
        if (walletConfirmed || get(stateConnectedWalletAddress)) {
            disconnect();
            stateWalletConfirmed.set(false);
            stateWalletAddress.set('');
        }
    }
    else {
        // bypass allows prelogin to set the correct form mode without clearing verified email and wallet
        formModeLockByPass = false;
    }
    stateReady.set(isReady(false)[0]);
});
loggedIn.subscribe(async (value) => {
    if (value === false && isLoggedIn !== false)
        stateReset();
    isLoggedIn = value;
});
stateEmailRegistered.subscribe((value) => (emailRegistered = value));
stateEmailVerified.subscribe((value) => {
    emailVerified = value;
    if (value) {
        stateShowVerifyEmail.set(false);
        log(`email verified, password is ${passwordRequired ? 'required' : passwordEnabled ? 'enabled' : 'not enabled'}`);
    }
    if (emailVerified && (passwordRequired || passwordEnabled))
        stateShowPassword.set(true);
});
stateFingerprint.subscribe((value) => {
    fingerprint = value;
    log(`auth fingerprint: ${fingerprint}`);
});
stateGeoblockReg.subscribe((value) => {
    log(`auth geoblock reg changed to ${value}`);
});
modalStack.subscribe(($modalStack) => {
    const entry = [...$modalStack].reverse().find((e) => e.modal === ModalDialog.Geoblock);
    if (!entry?.data)
        return;
    const data = entry.data;
    if (!data.label)
        return;
    lastGeoBlockPayload = { label: data.label, hard: Boolean(data.hard) };
});
statePasswordEnabled.subscribe((value) => (passwordEnabled = value));
statePasswordRequired.subscribe((value) => (passwordRequired = value));
stateTotpCode.subscribe((value) => (totpCode = value));
stateTotpEnabled.subscribe((value) => (totpEnabled = value));
// stateTotpRequired.subscribe((value) => (totpRequired = value));
stateTotpSecret.subscribe((value) => (totpSecret = value));
stateTotpSet.subscribe((value) => {
    totpSet = value;
    if (value && formMode === FormMode.Register)
        stateReady.set(isReady(true, true)[0]);
});
stateWalletAddress.subscribe(async (value) => {
    if (walletAddress === value)
        return;
    log(`wallet changed: ${walletAddress} -> ${value}`);
    walletAddress = value;
    resetPrelogin();
    // if (value) {
    // 	stateReady.set(isReady(true)[0]);
    // } else stateReady.set(false);
});
stateWalletConfirmed.subscribe(async (value) => {
    walletConfirmed = value;
    if (value) {
        await prelogin(LoginBy.Wallet);
    }
});
export const hide = () => {
    stateShow.set(null);
    closeThisModal(ModalDialog.Auth);
};
stateTab.subscribe((value) => {
    log(`auth state tab changed to ${value}`);
    switch (value) {
        case 'login':
            stateShow.set(FormMode.Login);
            break;
        case 'signup':
            stateShow.set(FormMode.Register);
            break;
    }
});
// Auto-open signup tab when attribution params detected (stag, campaign, or referral shortcode)
let hasCheckedAttribution = false;
const checkAttributionAndOpenSignup = () => {
    if (hasCheckedAttribution)
        return;
    let stag = null;
    let campaignCode = null;
    let campaignShortcode = null;
    // Subscribe to attribution stores
    const unsubStag = stateStag.subscribe((v) => (stag = v));
    const unsubCampaign = stateCampaignCode.subscribe((v) => (campaignCode = v));
    const unsubShortcode = stateCampaignShortcode.subscribe((v) => (campaignShortcode = v));
    // Check if any attribution exists
    if (stag || campaignCode || campaignShortcode) {
        hasCheckedAttribution = true;
        // Do not stack auth over the mobile pre-launch game info modal (player `/player/...` game URLs).
        if (get(stateOpenModal) === ModalDialog.GameInfo) {
            unsubStag();
            unsubCampaign();
            unsubShortcode();
            return;
        }
        stateShow.set(FormMode.Register);
        pushModal(ModalDialog.Auth, { tab: 'signup' });
    }
    // Cleanup subscriptions
    unsubStag();
    unsubCampaign();
    unsubShortcode();
};
// Run check when user is not logged in
loggedIn.subscribe((isLoggedIn) => {
    if (!isLoggedIn && !hasCheckedAttribution) {
        // Delay check to allow visit stores to populate
        setTimeout(checkAttributionAndOpenSignup, 500);
    }
});
